import { Checkbox, FormControlLabel, Grid, useEventCallback } from '@mui/material';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { AccordionCivilStatus } from 'shell/view-models/accordion-civil-status';
import { FormikTouched, FormikErrors } from 'formik';
import CivilStatusList from 'shell/components/shared/civil-status-list';

interface FormCivilStatusProps {
  errors?: FormikErrors<AccordionCivilStatus>;
  touched?: FormikTouched<AccordionCivilStatus>;
  values?: AccordionCivilStatus;
  disabled?: boolean;
  onChange: (
    key: keyof AccordionCivilStatus,
    value: AccordionCivilStatus[keyof AccordionCivilStatus]
  ) => void;
}

const FormCivilStatusComponent = ({
  values,
  onChange,
  errors,
  touched,
  disabled,
}: FormCivilStatusProps): React.ReactElement => {
  const handleCivilStatusListChange = useEventCallback((element: string | undefined) => {
    onChange('status', element);
  });

  return (
    <Grid container spacing={2}>
      <Grid item container spacing={2} xs={12} alignItems="center">
        <Grid item xs={12} md={6}>
          <CivilStatusList
            label="Stato civile"
            aria-label="Stato civile"
            value={values?.status || ''}
            disabled={disabled}
            onChange={handleCivilStatusListChange}
            error={touched?.status && Boolean(errors?.status)}
          />
        </Grid>
        <Grid item xs>
          <FormControlLabel
            control={
              <Checkbox
                id="availableStatus"
                disabled={disabled}
                checked={values?.available || false}
                onChange={() => onChange('available', !values?.available)}
                inputProps={{ 'aria-label': 'Stato civile non disponibile' }}
              />
            }
            label="Stato civile non disponibile"
          />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          label="Note"
          aria-label="Note"
          id="note"
          fullWidth
          disabled={disabled}
          multiline
          rows={5}
          inputProps={{
            maxLength: '240',
          }}
          value={values?.note || ''}
          onChange={(event) => {
            onChange('note', event?.target.value);
          }}
          error={touched?.note && Boolean(errors?.note)}
          helperText={errors?.note}
        />
      </Grid>
    </Grid>
  );
};

FormCivilStatusComponent.displayName = 'Form civil status component';

const FormCivilStatus = memo(FormCivilStatusComponent);

export default FormCivilStatus;
